import { type FC, type PropsWithChildren, useEffect } from 'react'

import { useHeaderStore } from '@/stores/useHeaderStore'

export const Title: FC<PropsWithChildren> = ({ children }) => {
  const title = useHeaderStore((state) => state.title)

  useEffect(() => {
    document.title = title ? `${title} | OPS Console` : 'OPS Console'
  }, [title])

  return <>{children}</>
}
